"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trafficTabClick = exports.trafficResize = exports.trafficOpen = exports.trafficDock = exports.trafficDrag = exports.trafficClose = exports.appResizeWidthSet = exports.appResizeHeightSet = exports.appOpenedSet = exports.appNotificationsSet = exports.appMinimizedSet = exports.appDragYSet = exports.appDragXSet = exports.appActiveTabSet = void 0;

var _constants = require("../constants");

var _traffic = require("../traffic");

var _types = require("./types");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var appActiveTabSet = function appActiveTabSet(tab) {
  return (
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(dispatch) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dispatch({
                  payload: tab,
                  type: _types.APP_ACTIVE_TAB_SET
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};

exports.appActiveTabSet = appActiveTabSet;

var appDragXSet = function appDragXSet(x) {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(dispatch) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                dispatch({
                  payload: x,
                  type: _types.APP_DRAG_X_SET
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
};

exports.appDragXSet = appDragXSet;

var appDragYSet = function appDragYSet(y) {
  return (
    /*#__PURE__*/
    function () {
      var _ref3 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3(dispatch) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                dispatch({
                  payload: y,
                  type: _types.APP_DRAG_Y_SET
                });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }()
  );
};

exports.appDragYSet = appDragYSet;

var appMinimizedSet = function appMinimizedSet(_ref4) {
  var minimized = _ref4.minimized,
      external = _ref4.external;
  return (
    /*#__PURE__*/
    function () {
      var _ref5 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4(dispatch) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return dispatch({
                  payload: minimized,
                  type: _types.APP_MINIMIZED_SET
                });

              case 2:
                if (minimized) {
                  _context4.next = 7;
                  break;
                }

                _context4.next = 5;
                return dispatch(trafficOpen({
                  external: external
                }));

              case 5:
                _context4.next = 9;
                break;

              case 7:
                _context4.next = 9;
                return dispatch(trafficClose());

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x4) {
        return _ref5.apply(this, arguments);
      };
    }()
  );
};

exports.appMinimizedSet = appMinimizedSet;

var appNotificationsSet = function appNotificationsSet(value) {
  return (
    /*#__PURE__*/
    function () {
      var _ref6 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee5(dispatch) {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return dispatch({
                  payload: value,
                  type: _types.APP_NOTIFICATIONS_SET
                });

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x5) {
        return _ref6.apply(this, arguments);
      };
    }()
  );
};

exports.appNotificationsSet = appNotificationsSet;

var appOpenedSet = function appOpenedSet(value) {
  return (
    /*#__PURE__*/
    function () {
      var _ref7 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee6(dispatch) {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return dispatch({
                  payload: value,
                  type: _types.APP_OPENED_SET
                });

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x6) {
        return _ref7.apply(this, arguments);
      };
    }()
  );
};

exports.appOpenedSet = appOpenedSet;

var appResizeHeightSet = function appResizeHeightSet(height) {
  return (
    /*#__PURE__*/
    function () {
      var _ref8 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee7(dispatch) {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                dispatch({
                  payload: height,
                  type: _types.APP_RESIZE_HEIGHT
                });

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      return function (_x7) {
        return _ref8.apply(this, arguments);
      };
    }()
  );
};

exports.appResizeHeightSet = appResizeHeightSet;

var appResizeWidthSet = function appResizeWidthSet(width) {
  return (
    /*#__PURE__*/
    function () {
      var _ref9 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee8(dispatch) {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                dispatch({
                  payload: width,
                  type: _types.APP_RESIZE_WIDTH
                });

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      return function (_x8) {
        return _ref9.apply(this, arguments);
      };
    }()
  );
};

exports.appResizeWidthSet = appResizeWidthSet;

var trafficClose = function trafficClose() {
  return (
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee9() {
      return regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              (0, _traffic.sendTrafficEvent)({
                eid: _constants.TRAFFIC_EID_CLOSE,
                type: _constants.TRAFFIC_TYPE_CLICK
              });

            case 1:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }))
  );
};

exports.trafficClose = trafficClose;

var trafficDrag = function trafficDrag() {
  return (
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee10() {
      return regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              (0, _traffic.sendTrafficEvent)({
                eid: _constants.TRAFFIC_EID_DRAG,
                type: _constants.TRAFFIC_TYPE_CUSTOM
              });

            case 1:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }))
  );
};

exports.trafficDrag = trafficDrag;

var trafficDock = function trafficDock() {
  return (
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee11() {
      return regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              (0, _traffic.sendTrafficEvent)({
                eid: _constants.TRAFFIC_EID_DOCK,
                type: _constants.TRAFFIC_TYPE_CLICK
              });

            case 1:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }))
  );
};

exports.trafficDock = trafficDock;

var trafficOpen = function trafficOpen(_ref13) {
  var external = _ref13.external;
  return (
    /*#__PURE__*/
    function () {
      var _ref14 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee12(dispatch, getState) {
        var _getState, opened;

        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _getState = getState(), opened = _getState.app.opened;
                (0, _traffic.sendTrafficEvent)({
                  eid: _constants.TRAFFIC_EID_OPEN,
                  type: _constants.TRAFFIC_TYPE_CLICK,
                  properties: {
                    external: external,
                    first: !opened
                  }
                });

              case 2:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      return function (_x9, _x10) {
        return _ref14.apply(this, arguments);
      };
    }()
  );
};

exports.trafficOpen = trafficOpen;

var trafficResize = function trafficResize() {
  return function ()
  /* dispatch, getState */
  {
    (0, _traffic.sendTrafficEvent)({
      eid: _constants.TRAFFIC_EID_RESIZE,
      type: _constants.TRAFFIC_TYPE_CUSTOM
    });
  };
};

exports.trafficResize = trafficResize;

var trafficTabClick = function trafficTabClick(_ref15) {
  var tab = _ref15.tab;
  return (
    /*#__PURE__*/
    function () {
      var _ref16 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee13(dispatch, getState) {
        var _getState2, activeTab;

        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _getState2 = getState(), activeTab = _getState2.app.activeTab;

                if (tab !== activeTab) {
                  (0, _traffic.sendTrafficEvent)({
                    eid: _constants.TRAFFIC_EID_TAB_CLICK,
                    type: _constants.TRAFFIC_TYPE_CLICK,
                    properties: {
                      name: tab
                    }
                  });
                }

              case 2:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));

      return function (_x11, _x12) {
        return _ref16.apply(this, arguments);
      };
    }()
  );
};

exports.trafficTabClick = trafficTabClick;